(function(){
  if(!window.Shopify||window.Shopify.locale!=='en')return;

  var s=document.createElement('style');s.textContent='.card__heading a{display:-webkit-box!important;-webkit-line-clamp:3!important;-webkit-box-orient:vertical!important;overflow:hidden!important}';document.head.appendChild(s);

  var b='https://cdn.shopify.com/s/files/1/0757/2842/1038/files/';
  var m={
    '1.png':'1_d25232a3-30bc-4f98-8212-2b34542000f0.png',
    '2.png':'3_9050f620-30cb-49e2-a150-e87f86f186e9.png',
    '3.png':'5_3eac0fae-d96f-4ec7-b5f2-4af4e151393a.png',
    '4.png':'2_e887dd74-517e-48b2-b57a-f583d78b7d2a.png',
    '5.png':'4_f40190d8-0dfe-446f-9652-89c20589884b.png',
    '6.png':'6_97ce8108-a3af-42fa-819a-017a078c49f3.png'
  };

  function swapImages(){
    document.querySelectorAll('img').forEach(function(img){
      var s=img.getAttribute('src')||'';
      var f=s.split('/').pop().split('?')[0];
      if(m[f]){ img.setAttribute('src',b+m[f]); }
      var ss=img.getAttribute('srcset')||'';
      if(ss){
        var entries=ss.split(',');
        var changed=false;
        var newEntries=entries.map(function(entry){
          var trimmed=entry.trim();
          var spIdx=trimmed.indexOf(' ');
          var url=spIdx>0?trimmed.substring(0,spIdx):trimmed;
          var desc=spIdx>0?trimmed.substring(spIdx):'';
          var slashIdx=url.lastIndexOf('/');
          var qIdx=url.indexOf('?',slashIdx);
          var fn=qIdx>0?url.substring(slashIdx+1,qIdx):url.substring(slashIdx+1);
          if(m[fn]){
            var prefix=url.substring(0,slashIdx+1);
            var qs=qIdx>0?url.substring(qIdx):'';
            url=prefix+m[fn]+qs;
            changed=true;
          }
          return url+desc;
        });
        if(changed) img.setAttribute('srcset',newEntries.join(','));
      }
    });
  }

  document.addEventListener('DOMContentLoaded',swapImages);
  window.addEventListener('load',function(){
    swapImages();
    setTimeout(swapImages,500);
    setTimeout(swapImages,1500);
    setTimeout(swapImages,3000);
  });

  var obs=new MutationObserver(function(muts){
    var needsSwap=false;
    muts.forEach(function(mut){
      if(mut.type==='childList') needsSwap=true;
      if(mut.type==='attributes'&&mut.target.tagName==='IMG') needsSwap=true;
    });
    if(needsSwap) swapImages();
  });
  document.addEventListener('DOMContentLoaded',function(){
    obs.observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['src','srcset']});
  });

  var deskUrl='https://cdn.shopify.com/s/files/1/0757/2842/1038/files/TOP3.jpg?v=1788499567';
  var mobUrl='https://cdn.shopify.com/s/files/1/0757/2842/1038/files/sp_ad22f3ab-78df-4aa1-b42e-cb58a5be4518.png';
  function applyBanner(){
    var el=document.querySelector('.banner__media');
    if(!el)return;
    el.style.setProperty('background-image','url('+(window.innerWidth>=750?deskUrl:mobUrl)+')','important');
    if(window.innerWidth>=750){el.style.setProperty('background-position','center bottom','important');}else{el.style.removeProperty('background-position');}
  }
  document.addEventListener('DOMContentLoaded',applyBanner);
  window.addEventListener('load',applyBanner);
  window.addEventListener('resize',applyBanner);
})();